let printView : boolean = false;

export class PrintViewService {
  public static setPrintView(value : boolean) {
    printView = value;
  }

  public static getPrintView() {
      return printView;
  }
}